// extracted by mini-css-extract-plugin
export default {"adjustedTable":"invoice-details_adjustedTable__UW+hV"};